import typography from '@amblique/king-living/app/theme/foundations/typography';

const {textStyles} = typography;

/** Multi-part styles for ProtectYourCover (KingGuard). Parts: root, title, description, checkboxRow, labelGroup, checkboxLabel, price. */
const ProtectYourCover = {
  parts: ['root', 'title', 'description', 'checkboxRow', 'labelGroup', 'checkboxLabel', 'price'],
  baseStyle: {
    root: {
      alignSelf: 'stretch',
      bg: 'white',
      borderRadius: 'base',
      overflow: 'hidden',
      width: '100%',
      marginTop: 4,
    },
    title: {
      ...textStyles.labelDefault,
      color: 'brandColors.greyscale90',
      fontVariantNumeric: 'lining-nums proportional-nums',
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 5,
    },
    description: {
      ...textStyles.bodyS,
      color: 'greyscale.70',
      fontVariantNumeric: 'lining-nums proportional-nums',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '20px 24px',
      sx: {
        '& p': {
          ...textStyles.bodyS,
          color: 'greyscale.70',
          fontVariantNumeric: 'lining-nums proportional-nums',
          margin: 0,
        },
        '& a': {
          ...textStyles.labelS,
          color: 'brandColors.primaryDarkLinen',
          textDecoration: 'underline',
          textDecorationStyle: 'solid',
          textDecorationSkipInk: 'none',
          textDecorationThickness: 'auto',
          textUnderlineOffset: '35%',
          textUnderlinePosition: 'from-font',
          cursor: 'pointer',
        },
      }
    },
    checkboxRow: {
      alignSelf: 'stretch',
      alignItems: 'center',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: 'brandColors.greyscale10',
      display: 'flex',
      gap: 4,
      paddingTop: 3.5,
      paddingRight: 5,
      paddingBottom: 3.5,
      paddingLeft: 6,
      width: '100%',
      sx: {
        '& > span:first-of-type': {
          flexShrink: 0,
          order: 1,
          marginLeft: 0,
        },
        '& > span:last-of-type': {
          flex: 1,
          minWidth: 0,
          order: 0,
          marginLeft: 0,
        },
        '& .chakra-checkbox__control': {
          w: 7.5,
          h: 7.5,
          minW: 7.5,
          minH: 7.5,
          borderRadius: '5.625px',
          borderWidth: '1.406px',
          borderStyle: 'solid',
          borderColor: 'brandColors.linen03',
          backgroundColor: 'text.white',
          boxShadow: 'none',
          _hover: {
            borderColor: 'brandColors.greyscale40',
          },
          _focus: {
            boxShadow: 'none',
          },
          _focusVisible: {
            boxShadow: '0 0 0 2px rgba(27, 26, 24, 0.25)',
          },
        },
        '& .chakra-checkbox__control[data-checked]': {
          borderWidth: '1.406px',
          backgroundColor: 'brandColors.greyscale',
          borderColor: 'brandColors.greyscale',
          color: 'white',
          _hover: {
            backgroundColor: 'brandColors.greyscale',
            borderColor: 'brandColors.greyscale',
          },
          _focus: {
            boxShadow: 'none',
          },
          _focusVisible: {
            boxShadow: '0 0 0 2px rgba(27, 26, 24, 0.45)',
          },
        },
        '& .chakra-checkbox__control[data-checked] svg': {
          color: 'white',
        },
        '& .chakra-checkbox__control[data-disabled]': {
          borderRadius: '5.625px',
          borderWidth: '1.406px',
          borderStyle: 'solid',
          borderColor: 'greyscale.30',
          backgroundColor: 'brandColors.greyscale10',
        },
        '& .chakra-checkbox__control[data-checked][data-disabled]': {
          borderRadius: '5.625px',
          borderWidth: '1.406px',
          borderStyle: 'solid',
          borderColor: 'greyscale.30',
          backgroundColor: 'brandColors.greyscale50',
        },
        '& .chakra-checkbox__label[data-disabled]': {
          fontSize: {base:'14px', lg: '16px'},
          opacity: 1,
          cursor: 'not-allowed',
          pointerEvents: 'none',
        },
        '& .chakra-checkbox__label[data-disabled] p': {
          fontSize: {base:'14px', lg: '16px'},
        }
      },
    },
    labelGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    checkboxLabel: {
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: '0.875rem', lg: '1rem'},
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.4,
      fontVariantNumeric: 'lining-nums proportional-nums',
    },
    price: {
      color: 'brandColors.greyscale70',
      flexShrink: 0,
      fontFamily: 'body',
      fontSize: '0.8125rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.2,
      textAlign: 'center',
      fontVariantNumeric: 'lining-nums proportional-nums',
    },
  },
};

export default ProtectYourCover;
